
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import SEOHead from '../../../components/feature/SEOHead';

export default function OrderConfirmation() {
  return (
    <>
      <SEOHead
        title="Order Confirmed | ignight"
        description="Thank you for your order. Your ignight candles are on their way."
        keywords="order confirmation, ignight candles"
      />
      <div className="min-h-screen bg-[#0B1B3A] flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center px-4 pt-24 pb-16">
          <div className="text-center max-w-md mx-auto">
            <div className="w-20 h-20 rounded-full bg-[#1A3A2A] flex items-center justify-center mx-auto mb-6 animate-bounce-once">
              <i className="ri-check-line text-[#5AE89E] text-3xl"></i>
            </div>
            <h1 className="text-2xl sm:text-3xl font-serif text-[#F5F0E8] mb-3">Thank You!</h1>
            <p className="text-sm text-[#8A9BB5] mb-2 leading-relaxed">
              Your order has been confirmed. We&rsquo;re preparing your candles with care.
            </p>
            <p className="text-sm text-[#6B83A8] mb-8">
              A confirmation email with tracking details will be sent to you shortly.
            </p>

            <div className="bg-[#0E2244] rounded-lg p-6 border border-[#1A3358] mb-8">
              <div className="flex items-center justify-center gap-3 mb-4">
                <i className="ri-truck-line text-[#D4C5A9] text-xl"></i>
                <span className="text-sm text-[#F5F0E8] font-medium">Estimated Delivery</span>
              </div>
              <p className="text-sm text-[#8A9BB5]">5-7 business days</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 bg-[#D4C5A9] text-[#0B1B3A] font-medium rounded-lg hover:bg-[#E5D6BA] transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                Continue Shopping
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
